import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { PERMITTED_VIEWS } from 'src/app/core/helpers/global/global.constant';
import { AVAILABLE_THEMES } from 'src/app/core/helpers/ui/ui.constant';
import { User } from 'src/app/core/interfaces/api/user.interface';
import { Theme } from 'src/app/core/interfaces/ui/ui.interface';
import { GlobalService } from 'src/app/core/services/ui/global.service';
import { QuickAccessService } from 'src/app/core/services/ui/quick-access.service';
import { UserActions } from 'src/app/core/states/auth/auth.actions';
import { changeTheme } from 'src/app/core/states/theme/theme.actions';
import { selectTheme } from 'src/app/core/states/theme/theme.selectors';
import { TYPES_USER_PERMISSIONS } from 'src/app/core/helpers/global/user-management.constant';

@Component({
  selector: 'shared-header-my-account',
  templateUrl: './my-account.component.html',
})
export class MyAccountComponent implements OnInit {
  @Input() messageCount: number = 0;

  public profileImg: string = 'assets/images/dashboard/profile.jpg';
  public urlProfile: string = 'profile/profile-detail';
  public profile: User = {} as User;
  public profile$: Observable<User> = this._globalService.profile;
  public name: string = '';
  public role: string | null | undefined = '';
  public userType: string | null | undefined = '';
  public currentLang: string = 'es';
  public isDark: boolean = false;
  public canCustomizeMenu: boolean = false;

  public USER_TYPES = TYPES_USER_PERMISSIONS;
  public PERMITTED_VIEWS = PERMITTED_VIEWS;

  constructor(
    private _router: Router,
    private _globalService: GlobalService,
    private _store: Store,
    private translate: TranslateService,
    private _quickAccessService: QuickAccessService
  ) {
    if (localStorage.getItem('user') !== null) {
    } else {
    }
  }

  ngOnInit() {
    this.loadProfile();
    const storedLang =
      localStorage.getItem('lang') ||
      this.translate.currentLang ||
      this.translate.getDefaultLang() ||
      'es';
    this.currentLang = storedLang;
    this.translate.use(this.currentLang);

    this._store.select(selectTheme).subscribe((theme) => {
      this.isDark = theme === AVAILABLE_THEMES.DARK_ONLY;
    });

    this._quickAccessService.getPermittedPages$().subscribe((pages) => {
      this.canCustomizeMenu = pages.length > 0;
    });
  }

  public logoutFunc() {
    this._store.dispatch(UserActions.userLogout());
  }

  private loadProfile() {
    this.profile$.subscribe((profile) => {
      if (profile && profile._id) {
        this.profile = profile;
        this.name = profile.firstName + ' ' + profile.lastName;
        this.role = profile.roleId?.name;
        this.userType = profile.userType;
      }
    });
  }
  public languageToggle(): void {
    const langs = ['es', 'en'];
    const current = this.translate.currentLang || this.currentLang || 'es';
    const next = langs[(langs.indexOf(current) + 1) % langs.length];
    this.translate.use(next);
    this.currentLang = next;
    localStorage.setItem('lang', next);
  }

  public layoutToggle(): void {
    const theme: Theme = this.isDark ? AVAILABLE_THEMES.LIGHT_ONLY : AVAILABLE_THEMES.DARK_ONLY;
    this._store.dispatch(changeTheme({ theme }));
  }

  public openMenuCustomizer(event: Event): void {
    event.stopPropagation();
    this._quickAccessService.openCustomizer();
  }

  public openMessages(event: Event): void {
    event.stopPropagation();
    // Navegar a la página de chats
    this._router.navigate(['/players/players-chat']);
  }
}
